// extracted by mini-css-extract-plugin
export default {"container":"ViewMerchantsTransaction_container__Gzrp4","content":"ViewMerchantsTransaction_content__gUmit","title":"ViewMerchantsTransaction_title__FHtnu"};